/* ========================================
   PRODUCT CARD - quick add + wishlist
   AJAX add to cart, no page reload
   ======================================== */

(function () {
  'use strict';

  function init() {
    /* ---------- Quick add (AJAX) ---------- */
    document.querySelectorAll('[data-quickadd-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const btn = form.querySelector('[data-quickadd-submit]');
        if (btn && btn.classList.contains('is-loading')) return;
        if (btn) btn.classList.add('is-loading');

        const formData = new FormData(form);

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:open'));
          })
          .catch(function (err) {
            console.error('Quick add error:', err);
            // Fallback: submit normally to /cart
            form.submit();
          })
          .finally(function () {
            if (btn) btn.classList.remove('is-loading');
          });
      });
    });

    /* ---------- Inline variant picker (SIZE → COLOR → add) ---------- */
    var productCache = {};

    function fetchProduct(handle) {
      if (productCache[handle]) return Promise.resolve(productCache[handle]);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      return fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('product fetch failed'); return r.json(); })
        .then(function (data) { productCache[handle] = data; return data; });
    }

    // Option metadata: name list, in Shopify's defined order
    function optionNames(product) {
      return (product.options || []).map(function (opt) {
        return (typeof opt === 'string' ? opt : (opt.name || '')).trim();
      });
    }

    // Human label per option name (EN + ID friendly)
    function optionLabel(name) {
      var n = (name || '').toLowerCase();
      if (n.indexOf('size') !== -1 || n.indexOf('ukuran') !== -1) return 'Select size';
      if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1 || n.indexOf('warna') !== -1) return 'Select color';
      return 'Select ' + (name || 'option');
    }

    // Unique values for option index N, filtered to variants compatible with
    // everything already chosen (state is an array indexed by option position).
    function valuesForStep(product, optIdx, state) {
      var seen = [];
      product.variants.forEach(function (v) {
        // must match all previously chosen options
        for (var i = 0; i < optIdx; i++) {
          if (state[i] != null && v.options[i] !== state[i]) return;
        }
        var val = v.options[optIdx];
        if (val && seen.indexOf(val) === -1) seen.push(val);
      });
      return seen;
    }

    // Is any in-stock variant reachable if we also pick `val` at optIdx,
    // given prior choices in state?
    function valueAvailable(product, optIdx, val, state) {
      return product.variants.some(function (v) {
        for (var i = 0; i < optIdx; i++) {
          if (state[i] != null && v.options[i] !== state[i]) return false;
        }
        return v.options[optIdx] === val && v.available;
      });
    }

    function money(cents) {
      if (window.SYNC && window.SYNC.formatMoneyShop) return window.SYNC.formatMoneyShop(cents);
      return '$' + (cents / 100).toFixed(2);
    }

    function addToCart(variantId, btn) {
      if (btn) btn.classList.add('is-loading');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:added'));
        })
        .finally(function () { if (btn) btn.classList.remove('is-loading'); });
    }

    // Render the next unanswered option as a step. EVERY option becomes a step,
    // even if it has only one value — nothing is auto-skipped. Works for any
    // number of options (Size, Color, Material, …) in Shopify's order.
    function renderStep(panel, product, state) {
      var stepsEl = panel.querySelector('[data-inline-steps]');
      var names = optionNames(product);

      // find the first option position not yet chosen
      var optIdx = -1;
      for (var i = 0; i < names.length; i++) {
        if (state[i] == null) { optIdx = i; break; }
      }

      // all options chosen → resolve to a variant + add
      if (optIdx === -1) {
        resolveAndAdd(panel, product, state);
        return;
      }

      var values = valuesForStep(product, optIdx, state);
      stepsEl.innerHTML = '<div class="pcard__inline-label">' + optionLabel(names[optIdx]) + '</div>';
      var wrap = document.createElement('div');
      wrap.className = 'pcard__inline-opts';
      values.forEach(function (val) {
        var avail = valueAvailable(product, optIdx, val, state);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pcard__inline-opt' + (avail ? '' : ' is-soldout');
        b.textContent = val;
        if (!avail) b.disabled = true;
        b.addEventListener('click', function (e) {
          e.stopPropagation(); // don't let it bubble to the click-outside closer
          state[optIdx] = val;
          renderStep(panel, product, state);
        });
        wrap.appendChild(b);
      });
      stepsEl.appendChild(wrap);
    }

    // Match the variant from the full selection (state[] by option position) and add.
    function resolveAndAdd(panel, product, state) {
      var match = product.variants.find(function (v) {
        for (var i = 0; i < state.length; i++) {
          if (state[i] != null && v.options[i] !== state[i]) return false;
        }
        return true;
      });
      var stepsEl = panel.querySelector('[data-inline-steps]');
      if (!match || !match.available) {
        stepsEl.innerHTML = '<div class="pcard__inline-label">This combination is sold out</div>';
        return;
      }
      stepsEl.innerHTML = '<div class="pcard__inline-label">Adding…</div>';
      addToCart(match.id, panel).then(function () {
        closePanel(panel);
      }).catch(function () {
        stepsEl.innerHTML = '<div class="pcard__inline-label">Could not add. Try again.</div>';
      });
    }

    function openPanel(card) {
      var panel = card.querySelector('[data-inline-panel]');
      if (!panel) return;
      var handle = card.getAttribute('data-product-handle');
      panel.hidden = false;
      card.classList.add('pcard--inline-open');
      var stepsEl = panel.querySelector('[data-inline-steps]');
      stepsEl.innerHTML = '<div class="pcard__inline-label">Loading…</div>';
      fetchProduct(handle).then(function (product) {
        // state[] indexed by option position; null = not yet chosen
        var state = (product.options || []).map(function () { return null; });
        renderStep(panel, product, state);
      }).catch(function () {
        // Fallback: go to product page
        window.location.href = '/products/' + handle;
      });
    }

    function closePanel(panel) {
      panel.hidden = true;
      var card = panel.closest('[data-product-card]');
      if (card) card.classList.remove('pcard--inline-open');
    }

    // Close any other open inline panels (only one open at a time)
    function closeOthers(exceptCard) {
      document.querySelectorAll('.pcard--inline-open').forEach(function (c) {
        if (c === exceptCard) return;
        var p = c.querySelector('[data-inline-panel]');
        if (p) closePanel(p);
      });
    }

    document.querySelectorAll('[data-inline-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('[data-product-card]');
        if (!card) return;
        // Toggle: if already open, re-tapping the + (now ×) closes it
        if (card.classList.contains('pcard--inline-open')) {
          var panel = card.querySelector('[data-inline-panel]');
          if (panel) closePanel(panel);
        } else {
          closeOthers(card);
          openPanel(card);
        }
      });
    });

    // Click / tap anywhere outside an open card closes its picker (desktop + mobile)
    document.addEventListener('click', function (e) {
      var openCard = document.querySelector('.pcard--inline-open');
      if (!openCard) return;
      if (openCard.contains(e.target)) return; // click inside the open card → ignore
      var panel = openCard.querySelector('[data-inline-panel]');
      if (panel) closePanel(panel);
    });

    // Escape key closes the open picker
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openCard = document.querySelector('.pcard--inline-open');
      if (!openCard) return;
      var panel = openCard.querySelector('[data-inline-panel]');
      if (panel) closePanel(panel);
    });

    /* ---------- Wishlist (localStorage) ---------- */
    var WISHLIST_KEY = 'sync:wishlist';

    function getWishlist() {
      try {
        return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
      } catch (e) {
        return [];
      }
    }

    function saveWishlist(list) {
      try {
        localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
      } catch (e) {}
    }

    var wishlist = getWishlist();

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      if (wishlist.indexOf(handle) !== -1) {
        btn.setAttribute('aria-pressed', 'true');
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var idx = wishlist.indexOf(handle);
        if (idx === -1) {
          wishlist.push(handle);
          btn.setAttribute('aria-pressed', 'true');
        } else {
          wishlist.splice(idx, 1);
          btn.setAttribute('aria-pressed', 'false');
        }
        saveWishlist(wishlist);
        document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: wishlist.length } }));
      });
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
